import { useGetSessionUser, useGetTenantById } from '@/shared/api/generated/session/session';
import { useTenantId } from './use-tenant-id';

export function useCurrentUser() {
	const { data, isLoading } = useGetSessionUser();
	return {
		userId: data?.id,
		userName: data?.name,
		isLoading,
	};
}

export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
	const identifier = useTenantId();
	const { data, isLoading } = useGetTenantById({ identifier });
	return {
		isAdmin: data?.isAdmin ?? false,
		isLoading,
	};
}
